import apiClient from './client';
import { expeditionsApiUrl } from '../utils/runtime';

const baseUrl = expeditionsApiUrl || '/wp-json/pfandpirat/v1/expeditions';

export async function loadExpeditionState() {
  return apiClient.get(`${baseUrl}/me`);
}

export async function getExpeditionTileStatus(position = {}, { signal, compact = true } = {}) {
  const params = new URLSearchParams({
    latitude: position.latitude ?? '',
    longitude: position.longitude ?? '',
  });
  if (compact) params.set('compact', '1');

  return apiClient.get(`${baseUrl}/tile-status?${params.toString()}`, { signal });
}

export async function loadExpeditionTiles({ bbox = null, limit = 3000 } = {}) {
  const params = new URLSearchParams();

  if (
    bbox
    && [bbox.south, bbox.west, bbox.north, bbox.east].every((value) => Number.isFinite(Number(value)))
  ) {
    params.set('bbox', [bbox.south, bbox.west, bbox.north, bbox.east].join(','));
  }

  if (limit) {
    params.set('limit', String(limit));
  }

  const query = params.toString();
  return apiClient.get(`${baseUrl}/tiles${query ? `?${query}` : ''}`);
}

export async function scanExpeditionArea(position = {}) {
  return apiClient.post(`${baseUrl}/scan`, {
    latitude: position.latitude ?? null,
    longitude: position.longitude ?? null,
    accuracy: position.accuracy ?? null,
  });
}
